import axios from 'axios';
import { getPublicApiBaseUrl } from '../config/apiBase';

const publicApi = axios.create({
  baseURL: getPublicApiBaseUrl(),
  headers: { 'Content-Type': 'application/json' },
});

export function getTenantBrandingBySlug(slug) {
  return publicApi.get(`tenant-branding/${encodeURIComponent(slug)}`);
}
